import React, { memo, useState } from "react";

import { useFormContext } from "react-hook-form";

import { Box, Stack } from "@origin-digital/ods-core";

import IconBatteryCharging from "@/assets/battery_charging.svg";
import IconSolarEnergyGenerated from "@/assets/solar_generating.svg";
import IconSunAndBatteryCharging from "@/assets/SunAndBatteryCharging.svg";
import { StyledHeading, TileButtonGroupInput } from "@/components";
import { StyledQuestion } from "@/components/StyledQuestion";

import { Address } from "./Address";
import { systemType as systemTypeContent } from "./content.json";

export const SystemTypeAndAddress = memo(
  ({
    backRoute,
    nextRoute,
    hardStopRoute,
    batteryNextRoute,
  }: {
    backRoute: () => Promise<string>;
    nextRoute: () => Promise<string>;
    hardStopRoute: () => Promise<string>;
    batteryNextRoute: () => Promise<string>;
  }) => {
    const { setValue, getValues } = useFormContext();
    const [selectedSystemType, setSelectedSystemType] = useState(
      getValues("systemType") || "solar"
    );

    const icons = [
      <IconSolarEnergyGenerated
        color="secondary"
        key={"solarEnergyGenerated"}
      />,
      <IconSunAndBatteryCharging
        color="secondary"
        key={"sunAndBatteryCharging"}
      />,
      <IconBatteryCharging color="secondary" key={"batteryCharging"} />,
    ];
    const options = systemTypeContent.option as any;

    const handleOnChange = (event: string) => {
      setSelectedSystemType(event);
      setValue("systemType", event);
    };

    return (
      <StyledQuestion>
        <Box paddingTop="none" paddingX="none" marginBottom={"xxlarge"}>
          <Stack space="medium" data-id="test">
            <StyledHeading>{systemTypeContent.heading}</StyledHeading>
            <TileButtonGroupInput
              cols={3}
              name={systemTypeContent.id}
              options={options}
              icons={icons}
              handleOnChange={handleOnChange}
            />
          </Stack>
        </Box>
        <Address
          backRoute={backRoute}
          nextRoute={nextRoute}
          hardStopRoute={hardStopRoute}
          batteryNextRoute={batteryNextRoute}
          selectedSystemType={selectedSystemType}
        />
      </StyledQuestion>
    );
  }
);
